<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row gutter="10">
        <el-col span="12">
          <el-form-item
            :label="$l('form_label_parameter_id') || '参数ID'"
            prop="paramID"
          >
            <el-input
              clearable
              disabled
              v-model="formData.paramID"
              :placeholder="$l('form_label_pe_parameter_id') || '请输入参数ID'"
              :maxlength="2"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            :label="$l('from_label_parameters_state') || '参数状态'"
            prop="paramStatus"
          >
            <el-col>
              <el-radio-group v-model="formData.paramStatus" disabled>
                <el-radio label="Y">{{
                  $l('form_radio_available') || '可用'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('form_radio_unavailable') || '不可用'
                }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        :label="$l('form_label_parameter_name') || '参数名称'"
        prop="paramName"
      >
        <el-input
          clearable
          disabled
          v-model="formData.paramName"
          :placeholder="$l('form_label_pe_parameter_name') || '请输入参数名称'"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$l('form_label_parameter_value') || '参数值'"
        prop="paramValue"
      >
        <el-input
          clearable
          type="textarea"
          rows="3"
          v-model="formData.paramValue"
          :placeholder="$l('form_label_pe_parameter_value') || '请输入参数值'"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$l('form_label_parameter_explain') || '参数说明'"
        prop="paramDescription"
      >
        <el-input
          clearable
          type="textarea"
          rows="3"
          v-model="formData.paramDescription"
          :placeholder="
            $l('form_label_pe_parameter_explain') || '请输入参数说明'
          "
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    paramID: String
  },
  data() {
    return {
      regionShow: false,
      formData: { paramStatus: 'Y' },
      rules: {
        paramID: [
          {
            required: true,
            message: this.$l('form_label_pe_parameter_id') || '请输入参数ID',
            trigger: 'blur'
          }
        ],
        paramName: [
          {
            required: true,
            message:
              this.$l('form_label_pe_parameter_name') || '请输入参数名称',
            trigger: 'blur'
          }
        ],
        paramValue: [
          {
            required: true,
            message: this.$l('form_label_pe_parameter_value') || '请输入参数值',
            trigger: 'blur'
          }
        ],
        paramStatus: [
          {
            required: true,
            message: this.$l('form_label_parameter_status') || '请输入参数状态',
            trigger: 'blur'
          }
        ],
        paramDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pe_parameter_explain') || '请输入参数说明',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.paramID) return
      this.$api
        .sysParameterDetailApi({
          paramID: this.paramID
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .sysParameterSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success'
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          } else {
            return
          }
        })
    }
  }
}
</script>
